import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { GroupRegisterRequestBody, GroupRegisterResponse } from "./types";

export class GroupRegisterAPI extends BaseAPI<
  GroupRegisterRequestBody,
  GroupRegisterResponse
> {
  protected route = ApiRoutes.group.register;
  protected method = RequestMethod.POST;
}
